import { ValidatorFn, Validators } from '@angular/forms';

/** Must stay in sync with backend GroupRequest.GROUP_NAME_PATTERN. */
export const GROUP_NAME_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9 -]*$/;

export const GROUP_NAME_MAX_LENGTH = 100;

export const GROUP_NAME_HINT =
  'Use letters, numbers, spaces, and hyphens only.';

export const GROUP_NAME_REQUIRED_MESSAGE = 'Group name is required.';

export const GROUP_NAME_INVALID_MESSAGE =
  'Group name must start with a letter or number and contain only letters, numbers, spaces, and hyphens.';

export const GROUP_NAME_MAX_LENGTH_MESSAGE =
  'Group name must be 100 characters or fewer.';

export function getGroupNameValidators(): ValidatorFn[] {
  return [
    Validators.required,
    Validators.maxLength(GROUP_NAME_MAX_LENGTH),
    Validators.pattern(GROUP_NAME_PATTERN),
  ];
}

export function getGroupNameErrorMessage(
  errors: Record<string, unknown> | null | undefined
): string {
  if (!errors) {
    return '';
  }
  if (errors['required']) {
    return GROUP_NAME_REQUIRED_MESSAGE;
  }
  if (errors['maxlength']) {
    return GROUP_NAME_MAX_LENGTH_MESSAGE;
  }
  if (errors['pattern']) {
    return GROUP_NAME_INVALID_MESSAGE;
  }
  return GROUP_NAME_INVALID_MESSAGE;
}
